import coverStyles from "./cover.module.css";
import { SiteSurvey } from "api/types/siteSurvey";

export function Cover({
  survey,
  logoUrl,
  coverUrl,
  rating,
}: {
  survey: SiteSurvey;
  logoUrl?: string;
  coverUrl?: string;
  rating?: number;
}) {
  return (
    <div className="d-flex my-3 justify-content-between h-100">
      <div className="d-flex flex-column justify-content-center  w-100 align-content-center">
        <div className="">Prepared For:</div>
        {logoUrl && (
          <img
            src={logoUrl}
            className={`img-fluid ${coverStyles.preparedForImg}`}
            alt=""
          />
        )}
        <address>
          <div>{survey.customer}</div>
          <div>{survey.clientName}</div>
          <div>{survey.address}</div>
          <div>
            {survey.city} {survey.state} {survey.zip}
          </div>
        </address>
        {rating !== undefined && (
          <>
            <div style={{ width: "50%" }}>
              Evergreen Air Conditioning rates these units {rating} out of 5.
            </div>
            <div className="text-muted" style={{ fontSize: "0.75rem" }}>
              (Rating scale: 1 being worst, 5 being best)
            </div>
          </>
        )}
      </div>
      <div className="d-flex flex-column justify-content-center w-100 ">
        {coverUrl && (
          <img
            src={coverUrl}
            className={`img-fluid ${coverStyles.imgFit}`}
            alt=""
          />
        )}
      </div>
    </div>
  );
}
